const TableNumber = (page, dataLength, index) => {
  const tableNum = page * dataLength + (index + 1) - dataLength

  return tableNum
}

export default TableNumber